import type { PanelItem } from './types';

export const panelPrefix = 'panel_';

/**
 * The list that renders panels holds one entry type, and TypeScript cannot
 * relate `PanelItem<P>` to `PanelItem` for a generic `P`.
 */
export const panelPropsGuard = <P extends object>(
  panel: PanelItem<P>,
): PanelItem =>
  // biome-ignore lint/plugin: see above.
  panel as PanelItem;
